const API_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";

export const SHOPPING_LISTS_ENDPOINTS = {
  CREATE: `${API_BASE_URL}/shopping-lists`,
  GET_CURRENT: `${API_BASE_URL}/shopping-lists/current`,
  SEND_CURRENT_EMAIL: `${API_BASE_URL}/shopping-lists/current/email`,
  GET_SUPERMARKETS: `${API_BASE_URL}/shopping-lists/supermarkets`,
  UPDATE_ITEM: (listId: string, itemId: string) => `${API_BASE_URL}/shopping-lists/${listId}/items/${itemId}`,
} as const;

export { API_BASE_URL };
